import { all } from 'redux-saga/effects';
import overtimeWatcher from './overTimeSaga';

export default function* rootSaga(action) {
	yield all([overtimeWatcher(action)]);
}
